// Design tokens for the app.
//
// This UI is used as a teleprompter during live interviews: the window is made
// very small and parked below the webcam. Density and legibility at small sizes
// are hard requirements — prefer tight spacing and strong text contrast over
// generous whitespace.

const theme = {
  color: {
    // Surfaces
    bg: "#f1f5f9",
    surface: "#ffffff",
    brick: "#dde5ee",
    brickHover: "#eaf0f7",
    border: "#cbd5e1",
    borderSubtle: "#e2e8f0",

    // Text — kept dark for glanceability at small sizes
    text: "#0f172a",
    textMuted: "#475569",
    textFaint: "#64748b",

    // Intent
    accent: "#1e293b",
    accentHover: "#334155",
    danger: "#dc2626",
    dangerBg: "#fee2e2",
    focus: "#2563eb",
  },

  // Compact scale — the navbar and chrome must not eat reading space.
  space: {
    xs: "0.25rem",
    sm: "0.375rem",
    md: "0.625rem",
    lg: "1rem",
    xl: "1.5rem",
  },

  radius: {
    sm: "4px",
    md: "6px",
    pill: "999px",
  },

  // Fixed control height used by the navbar row, so everything aligns.
  control: "28px",

  font: {
    xs: "0.75rem",
    sm: "0.8125rem",
    md: "0.875rem",
    lg: "1rem",
    xl: "1.125rem",
  },

  shadow: {
    brick:
      "0 1px 2px rgba(15, 23, 42, 0.12), inset 0 0 0 1px rgba(255, 255, 255, 0.35)",
    brickHover:
      "0 3px 6px rgba(15, 23, 42, 0.16), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
    panel: "0 4px 12px rgba(15, 23, 42, 0.12)",
  },

  z: {
    nav: 100,
    panel: 200,
    modal: 900,
    toast: 1000,
  },
};

// The brick texture, shared by topic and subtopic pills. Extracted so the two
// stay identical — they were duplicated and had already drifted apart.
export const brickTexture = `
  background-image: linear-gradient(
      45deg,
      rgba(15, 23, 42, 0.04) 25%,
      transparent 25%,
      transparent 75%,
      rgba(15, 23, 42, 0.04) 75%
    ),
    linear-gradient(
      -45deg,
      rgba(15, 23, 42, 0.04) 25%,
      transparent 25%,
      transparent 75%,
      rgba(15, 23, 42, 0.04) 75%
    );
  background-size: 20px 20px;
`;

export default theme;
